// Українська (User Panel)
const uk = {
  common: {
    loading: "Завантаження...",
    back: "Назад",
    cancel: "Скасувати",
    confirm: "Підтвердити",
    save: "Зберегти",
    saved: "Збережено",
    submit: "Надіслати",
    submitting: "Надсилання...",
    saving: "Збереження...",
    ok: "OK",
    error: "Помилка",
    success: "Успішно",
    pending: "Очікує",
    approved: "Схвалено",
    rejected: "Відхилено",
    completed: "Завершено",
    all: "Усі",
    failed: "Невдало",
    select_language: "Виберіть мову",
    language: "Мова",
    unable_server: "Не вдалося зв'язатися з сервером. Спробуйте ще раз.",
    fill_all: "Будь ласка, заповніть усі поля",
    hint_disabled: "Поповнення та виведення тимчасово вимкнено",
    account_disabled:
      "Операції вимкнено для вашого облікового запису. Зверніться до служби підтримки.",
  },

  navbar: {
    home: "Головна",
    history: "Історія",
    starting: "Старт",
    services: "Сервіси",
    my_profile: "Мій профіль",
  },

  page: {
    home: "Головна",
    history: "Історія",
    services: "Сервіси",
    deposit: "Поповнення",
    withdraw: "Виведення",
    widthraw_page: "Виведення",
    withdrawal_account: "Рахунок для виведення",
    deposit_history: "Історія поповнень",
    withdraw_history: "Історія виведень",
    starting: "Старт",
    my_profile: "Мій профіль",
    security_pin: "PIN-код",
    login_password: "Пароль для входу",
    invite_friends: "Запросити друзів",
    about_us: "Про нас",
    faq: "FAQ",
    vip_rules: "Правила VIP",
    invitation_rules: "Правила запрошень",
    about_us_details: "Про нас",
  },

  home: {
    welcome: "Ласкаво просимо",
    vip_level: "Рівні VIP",
    popular: "Популярне",
    deposit: "Поповнення",
    withdrawal: "Виведення",
    about_us: "Про нас",
    invite_friends: "Запросити друзів",
  },

  deposit: {
    title: "Поповнення",
    amount_label: "Сума поповнення",
    total_balance: "Загальний баланс",
    bank_card: "Банківська картка",
    quick_selection: "Швидкий вибір",
    err_amount: "Введіть, будь ласка, коректну суму поповнення",
    range_hint: "Допустимий діапазон для {vip}: {min} - {max}",
    err_below: "Сума поповнення не може бути меншою за {min}",
    err_above: "Сума поповнення не може перевищувати {max}",
    err_loading_card: "Зачекайте, завантажуємо вашу банківську картку",
    err_add_card:
      "Спочатку додайте банківську картку в розділі Мій профіль → Рахунок для виведення",
    info_title: "Дані банківської картки",
    info_hint:
      "Дані банківської картки автоматично беруться з вашого рахунку для виведення (Мій профіль).",
    bank_name: "Назва банку",
    card_number: "Номер картки",
    account_holder: "Ім'я власника рахунку",
    ph_bank_name: "Введіть назву банку",
    ph_card_number: "Введіть номер картки",
    ph_account_holder: "Введіть ім'я на банківському рахунку",
    waiting_title: "Очікуємо підтвердження....",
    waiting_text:
      "Ваш запит на поповнення надіслано. Зачекайте на підтвердження адміністратора.",
  },

  withdraw: {
    title: "Виведення",
    amount_label: "Сума виведення",
    total_balance: "Загальний баланс",
    method_title: "Спосіб виведення",
    method_hint:
      "Ці дані беруться з вашого рахунку для виведення (Мій профіль) і не можуть бути змінені тут.",
    bank_card: "Банківська картка",
    usdt: "USDT",
    wise: "Wise",
    revolut: "Revolut",
    bank_name: "Назва банку",
    bank_account: "Банківський рахунок/USDT",
    full_name: "Повне ім'я",
    usdt_address: "Адреса USDT",
    usdt_protocol: "Протокол USDT",
    wise_email: "Ел. пошта облікового запису Wise",
    wallet_address: "Адреса гаманця",
    security_pin: "PIN-код безпеки",
    time_title: "Час виведення",
    time_text:
      "Виведення коштів дозволено лише з 01:00:00 до 17:00:00. Спробуйте ще раз у цей час.",
    success: "Запит на виведення надіслано, очікуємо підтвердження",
    err_amount: "Введіть, будь ласка, коректну суму виведення",
    err_pin: "Введіть, будь ласка, ваш PIN-код",
    err_loading: "Зачекайте, завантажуємо ваш рахунок для виведення",
    err_details:
      "Спочатку додайте дані ({method}) в розділі Мій профіль → Рахунок для виведення",
    err_bank: "Заповніть назву банку, номер рахунку та повне ім'я",
    err_usdt: "Заповніть адресу USDT та повне ім'я",
    err_wise: "Заповніть ел. пошту облікового запису Wise та повне ім'я",
    err_revolut: "Заповніть адресу гаманця та повне ім'я",
    limit_title: "Помилка запиту",
    err_below: "Сума виведення не може бути меншою за {min}",
    err_above: "Сума виведення не може перевищувати {max}",
    err_daily: "Денний ліміт виведення досягнуто. Дозволено {count} виведення(нь) на день.",
  },

  waccount: {
    title: "Рахунок для виведення",
    hint:
      "Ці дані автоматично використовуються для поповнення та виведення. Після надсилання вони зберігаються в списку банківських карток адміністратора.",
    usdt_number: "Номер USDT",
    confirm_text: "Ви впевнені, що хочете зберегти дані рахунку для виведення?",
    saved_success: "Рахунок для виведення успішно збережено",
  },

  history: {
    pending: "Очікує",
    completed: "Завершено",
    no_records: "Записів не знайдено",
    total_amount: "Загальна сума:",
    profit: "Прибуток:",
    volume: "Обсяг транзакцій:",
    order_submitted: "Замовлення успішно надіслано",
  },

  start: {
    current: "Поточний",
    profit: "Прибуток:",
    application: "Заявок:",
    welcome: "Привіт! Ласкаво просимо",
    commission_details: "Деталі комісії",
    today_profit: "Прибуток за сьогодні",
    account_balance: "Баланс облікового запису",
    starting: "Старт",
    important_notice: "Важливе повідомлення",
    working_hours: "• Графік роботи: 09:00:00 - 23:58:59",
    contact_line:
      "• Якщо є питання, зверніться до онлайн-служби підтримки!",
    processing: "Обробка...",
    start: "Старт",
    order_product: "Товар замовлення",
    rating: "Рейтинг:",
    price: "Ціна:",
    commission: "Комісія:",
    order_done:
      "Замовлення виконано! Прибуток {amount} додано на ваш баланс.",
    unable_server: "Не вдалося зв'язатися з сервером",
  },

  sv: {
    online: "Онлайн",
    customer: "Підтримка",
    services: "Клієнти",
  },

  mp: {
    invitation_code: "Код запрошення",
    credit_reputation: "Кредитна репутація",
    today_profit: "Прибуток за сьогодні",
    account_balance: "Баланс облікового запису",
    orders_count: "Кількість замовлень",
    invite_friends: "Запросити друзів",
    invite_subtitle: "Запрошуйте друзів і отримуйте нагороди",
    logout: "Вийти",
    logout_confirm: "Ви впевнені, що хочете вийти?",
    footer: "Copyright © 2023 Nativz. Усі права захищено.",
    user: "Користувач",
  },

  lp: {
    old_password: "Старий пароль",
    new_password: "Новий пароль",
    confirm_password: "Підтвердіть новий пароль",
    note:
      "Якщо ви забули старий пароль для входу, зверніться до служби підтримки.",
    err_min: "Новий пароль повинен містити щонайменше 6 символів",
    err_mismatch: "Новий пароль і підтвердження пароля не збігаються",
  },

  sp: {
    old_pin: "Старий PIN",
    new_pin: "Новий PIN",
    confirm_pin: "Підтвердіть новий PIN",
    note:
      "Якщо ви забули старий PIN-код, зверніться до служби підтримки.",
    err_min: "Новий PIN повинен містити щонайменше 6 символів",
    err_mismatch: "Новий PIN і підтвердження PIN не збігаються",
  },

  dh: {
    title: "Історія поповнень",
    empty: "Історії поповнень поки немає",
  },

  wh: {
    title: "Історія виведень",
    empty: "Історії виведень поки немає",
  },

  ifr: {
    title: "Запросити друзів",
    link_copied: "Посилання скопійовано",
    copy_prompt: "Скопіюйте це посилання:",
  },

  faq: {
    title: "FAQ",
    important_reminder: "Важливе нагадування",
    reminder_text:
      "Будь-яка зловмисна діяльність з відмивання грошей суворо заборонена. У разі виявлення платформа заморозить наведені нижче облікові записи та вживе відповідних правових заходів.",
    deposit_heading: "Поповнення",
    deposit_text:
      "Кожне поповнення необхідно надіслати до служби підтримки для поповнення вашого облікового запису. Після переказу коштів на рахунок, наданий командою підтримки платформи, надайте підтвердження успішного переказу. Щоб забезпечити миттєве зарахування поповнення, переконайтеся, що ім'я отримувача та сума переказу збігаються. Якщо в процесі поповнення виникли нерозв'язані питання, зверніться до служби підтримки. Через велику кількість інформації уважно перевірте деталі перед завершенням операції. Платформа може періодично змінювати дані вашого облікового запису. Якщо в процесі поповнення виникли нерозв'язані питання, зверніться до служби підтримки. Якщо у вас є питання, зверніться до онлайн-служби підтримки платформи.",
    withdraw_heading: "Виведення коштів",
    withdraw_text:
      'Перед виведенням коштів прив\'яжіть адресу для виведення до платформи. Щоб вивести кошти, перейдіть на екран "Виведення коштів" на головній сторінці, натисніть кнопку "Виведення" та введіть суму, яку хочете вивести, і пароль для виведення.',
    note: "(Примітка: зверніться до нашої служби підтримки за допомогою.)",
  },

  ir: {
    title: "Правила запрошень",
    p1: "Учасники платформи можуть використовувати реферальні коди, щоб запрошувати інших до вашої команди. Ви отримаєте відсоткову комісію з заробітку учасників вашої команди. Заробіток повертатиметься вам напряму через ваш обліковий запис на платформі або у звітах вашої команди.",
    notice: "Повідомлення:",
    p2: "Усі агенти та їхні підпорядковані учасники отримують певний відсоток доходу та бонусів від платформи. Дохід становить 30% комісій, зароблених їхніми підпорядкованими учасниками. Платформа не надає підтримки для розвитку підпорядкованих учасників команди та не впливає негативно на дохід і бонуси агентів.",
  },

  vr: {
    title: "Правила VIP",
    p1: "VIP 1 складається з 30 замовлень за цикл. Для виконання цих замовлень потрібен мінімальний баланс 25 USDT. Ліміт виведення для цього рівня становить від 100 USDT до максимум 5 000 USDT.",
    p2: "VIP 2 складається з 40 замовлень за цикл. Для переходу на VIP 2 потрібен мінімальний депозит 1 500 USDT. Ліміт виведення для цього рівня становить від 100 USDT до максимум 10 000 USDT.",
    p3: "VIP 3 складається з 50 замовлень за цикл. Для відкриття VIP 3 потрібен мінімальний депозит 5 000 USDT. Ліміт виведення для цього рівня становить від 100 USDT до максимум 50 000 USDT.",
    p4: "VIP 4 складається з 60 замовлень за цикл. Для відкриття VIP 4 потрібен мінімальний депозит 10 000 USDT. Ліміт виведення для цього рівня становить від 100 USDT до максимум 1 000 000 USDT. Користувачі VIP 4 також отримують додаткову комісію 10% порівняно з нижчими рівнями VIP.",
  },

  ad: {
    title: "Про нас",
    intro:
      "Умови реєстрації як партнера, магазина, платформи або співробітника в Oneforma.",
    h_agreement: "Ваша угода",
    p1: '1. Перед використанням, переглядом або створенням облікового запису на платформі oneforma.com ("OneForma") уважно прочитайте ці умови ("Умови", "Умови та положення"). Ваш доступ до OneForma та її використання залежать від вашого прийняття та дотримання цих Умов, а також CENTIFIC GLOBAL SOLUTIONS, Inc. ("CENTIFIC"). Ці Умови поширюються на всіх відвідувачів, користувачів, глядачів та інших осіб, які отримують доступ до OneForma або використовують її.',
    p2: '2. Надаючи будь-які послуги або виконуючи будь-які проєкти, виділені на платформі Oneforma, ви підтверджуєте, що ви ("ваш", ваш партнер, магазин-партнер, платформа-партнер та персонал) уклали з CENTIFIC Угоду про надання послуг, яка містить умови та положення, застосовні положення законодавства, опис послуг або робоче замовлення та інші письмові документи, узгоджені обома сторонами ("Угода"). У разі суперечності між цими Умовами та будь-якими раніше укладеними вами угодами з цього питання мають перевагу ці Умови.',
    p3: "3. Реєструючись в OneForma або використовуючи її, ви погоджуєтеся дотримуватися цієї Угоди. Якщо ви не погоджуєтеся з будь-яким пунктом або з усією Угодою в цілому, ви не можете реєструватися в OneForma.",
    h_relationships: "Стосунки між усіма сторонами",
    p4: "1.1. Роль CENTIFIC. OneForma — це платформа під управлінням CENTIFIC, розташована за адресою 14980 NE 31st Way, Suite 100, Redmond, WA 98052. Контактна ел. пошта: omegaguttakdl53@gmail.com",
    p5: 'CENTIFIC надає платформу OneForma, дозволяючи користувачам самостійно ухвалювати рішення про укладання угод. Ви надаєте послуги третім особам або CENTIFIC ("Власник проєкту"), які доручають роботу чи проєкти в OneForma. Будь-які послуги чи робота, які ви виконуєте відповідно до цієї угоди, призначені для Власника проєкту та не є частиною звичайної господарської діяльності CENTIFIC ("Послуги").',
    h_deliverables: "1.2. Результати",
    p6: "CENTIFIC не надасть вам постійного робочого місця та не вимагатиме виконання послуг у спеціально обладнаному місці. Ви самостійно визначаєте місце роботи для кожного проєкту. Для будь-якого проєкту, що потребує роботи на місці, ви залишаєте за собою абсолютне право відмовитися від такого проєкту.",
    h_statement: "1.3. Ваша заява",
    p7: "Читаючи цю угоду, ви заявляєте та гарантуєте CENTIFIC, що:",
    p8: "Ви зазвичай займаєтеся самостійно встановленою торгівлею або підприємницькою діяльністю того самого характеру, що й послуги за цією Угодою. Ви або персонал проєкту повинні мати навички, досвід та кваліфікацію, необхідні для надання послуг;",
    p9: "Ви або ваша команда проєкту повинні надавати послуги професійно та кваліфіковано, дотримуючись найкращих галузевих стандартів для аналогічних послуг і виконуючи вимоги як центрального уряду, так і власника проєкту. Ви або ваша команда проєкту повинні виділяти достатні ресурси для своєчасного та надійного надання послуг.",
    p10: "Ви або ваш персонал проєкту повинні виконувати послуги відповідно до всіх застосовних федеральних, штатних та інших національних і місцевих законів та нормативних актів, включаючи збереження всіх ліцензій, дозволів і реєстрацій, необхідних для надання послуг;",
    p11: "Ви маєте право укладати цю угоду, наймати персонал проєкту або надавати відповідно до відповідних умов цієї угоди, і ви несете повну відповідальність за виконання всіх послуг за цією угодою;",
    p12: "Ви забезпечуєте за власний рахунок усі матеріали, обладнання, приладдя та інші ресурси, необхідні для виконання Послуг, включаючи будь-які відрядження чи інші витрати, понесені вами або вашим персоналом проєкту під час виконання Послуг; ви та ваш персонал проєкту не мають права на відпустку, групове медичне або страхування життя, страхування від непрацездатності, участь у прибутках або пенсійні пільги, а також на будь-які інші додаткові пільги чи програми добробуту, які CENTIFIC надає своїм співробітникам; CENTIFIC не несе відповідальності за утримання чи сплату будь-якого податку на доходи, зарплат, податків на соціальне страхування чи інших федеральних, штатних або місцевих податків, сплату будь-яких страхових внесків (включаючи внески на страхування від безробіття чи непрацездатності) або отримання страхування від нещасних випадків на виробництві від вашого імені, якщо інше не передбачено застосовним законодавством; ви зобов'язані відшкодовувати CENTIFIC усі такі податки або внески, включаючи штрафи та відсотки, і ви відмовляєтеся від будь-якого права вимагати від CENTIFIC відшкодування будь-якої шкоди, яку ви (а також ваші співробітники та підрядники) можете зазнати під час виконання Послуг за цією Угодою.",
    h_term: "2. Строк і розірвання",
    p13: "2.1. Ця Угода набирає чинності з дати реєстрації як власника облікового запису OneForma та діє до її розірвання за взаємною згодою вас і CENTIFIC або будь-якою зі сторін відповідно до розділу 2.2.",
    p14: "2.2. Розірвання. Незалежно від будь-якого протилежного положення цієї Угоди, CENTIFIC може розірвати вашу реєстрацію в OneForma у будь-який час, з будь-якої причини або без неї, письмово повідомивши за 30 днів. На додаток до будь-яких засобів правового захисту, передбачених цією Угодою, CENTIFIC також може розірвати цю Угоду негайно після повідомлення вас, якщо ви:",
    p15: "До або в момент підписання цієї Угоди Компанія не надала відповідну інформацію чи документи, обґрунтовано запитані CENTIFIC, або надала CENTIFIC хибну чи оманливу інформацію чи документи.",
    p16: "Займаєтеся будь-якою шахрайською діяльністю, включаючи, але не обмежуючись:",
    p17: "Підробленням вашої картки відвідуваності; завищенням цін; введенням в оману чи вчиненням шахрайських заяв щодо CENTIFIC або власника проєкту з використанням автоматичних машин для виконання послуг без попередньої згоди власника проєкту;",
    p18: "Істотним порушенням цієї Угоди та Угоди про нерозголошення, якщо таке порушення є непорушним, або навіть якщо воно може бути усунуте, не усувається протягом 7 днів з моменту повідомлення про таке порушення; або порушенням будь-якої заяви чи гарантії, наданої вами відповідно до цієї Угоди або відповідного SOW.",
    p19: "Ви можете розірвати цю Угоду, видаливши свій обліковий запис із OneForma. У цьому випадку ви повинні надати CENTIFIC письмову заяву із зазначенням загальної суми, яку CENTIFIC вам заборгував на дату розірвання. CENTIFIC сплатить цю суму відповідно до умов і процедури, викладених у розділі 3 цих Умов.",
    p20: "Ви розумієте та визнаєте, що закриття будь-якого проєкту або розірвання будь-якого SOW не призводить автоматично до розірвання цієї Угоди. і ваш доступ до OneForma було припинено.",
    h_consequences: "2.3. Наслідки розірвання",
    p21: "Коли ця Угода спливає або розривається з будь-якої причини, а також в будь-який інший час на письмову вимогу CENTIFIC або Власника проєкту, ви зобов'язані протягом трьох днів після такого спливу або розірвання передати CENTIFIC та/або Власнику проєкту всі результати (завершені або незавершені), а також усі матеріали, обладнання та інше майно, надане вам CENTIFIC або Власником проєкту для використання;",
    p22: "Передати CENTIFIC або власнику проєкту всі матеріальні документи та інші носії, включаючи будь-які копії, які містять, відображають, включають або ґрунтуються на конфіденційній інформації;",
    p23: "Ви повинні назавжди видалити всю конфіденційну інформацію з вашого комп'ютера та фотосистеми; і надати CENTIFIC та власнику проєкту письмове підтвердження дотримання вимог цього розділу. Якщо інше не передбачено законом, після закриття вашого облікового запису ви більше не матимете доступу до будь-якої інформації чи матеріалів, збережених вами в OneForma, а будь-який вміст, збережений у вашому обліковому записі, може бути видалено, за що CENTIFIC прямо відмовляється від будь-якої відповідальності. CENTIFIC може зберігати частину або всю інформацію вашого облікового запису, якщо це дозволено або вимагається законом та політиками конфіденційності.",
    h_payment: "3. Оплата",
    h_payment_method: "3.1 Спосіб оплати",
    p24: "Платежі за замовчуванням здійснюються через Payoneer. Укладаючи договір із Payoneer або надаючи платіжну інформацію Payoneer через OneForma, ви підтверджуєте та погоджуєтеся, що: (а) ваш обліковий запис Payoneer та пов'язані послуги з управління коштами регулюються виключно умовами Payoneer; (б) CENTIFIC не несе перед вами відповідальності за послуги з управління коштами, надані Payoneer, і не дає жодних заяв чи гарантій щодо таких послуг; (в) CENTIFIC не несе прямої чи опосередкованої відповідальності за будь-яку фактичну або ймовірну шкоду чи збитки, що виникли внаслідок використання або покладання на послуги з управління коштами, надані Payoneer; і (г) ви безвідклично відмовляєтеся від будь-яких претензій до CENTIFIC та його афілійованих осіб у зв'язку з такими послугами. Якщо ви надаєте перевагу іншим способам оплати, напишіть на omegaguttakdl53@gmail.com",
    p25: "Ви також підтверджуєте та погоджуєтеся, що CENTIFIC не несе відповідальності за будь-які збої платежів, спричинені застосовним законодавством або будь-якими обмеженнями, накладеними вашою фінансовою установою, а також за будь-які кредитні чи дебетові записи фінансової установи, що стосуються вашого облікового запису Payoneer або будь-якого іншого способу оплати, узгодженого вами та CENTIFIC. CENTIFIC докладатиме комерційно обґрунтованих зусиль для спільної роботи з вами щодо врегулювання таких транзакцій у спосіб, сумісний із цією Угодою та будь-яким застосовним законодавством.",
    h_currency: "3.2. Валюта та процедури оплати",
    p26: "Залежно від власника проєкту та послуг, які ви обираєте для виконання, CENTIFIC може на власний розсуд здійснювати оплату в доларах США, юанях або будь-якій іншій валюті.",
    h_prepay: "3.3. Правила передоплати",
    p27: "Ми співпрацюємо з готельними партнерами, і ваша поточна робота з бронюванням здійснюється на основі передоплати. Оскільки OneForma надає лише платформу з частковою зайнятістю всім учасникам, вам необхідно внести кошти заздалегідь, перш ніж братися за завдання з передоплатою. Після завершення кожного замовлення система автоматично поверне зароблену суму та вашу комісію. Тому вам необхідно почати роботу на основі передоплати. Реєструючись в OneForma або використовуючи її, ви погоджуєтеся дотримуватися цієї угоди. Якщо ви не погоджуєтеся з будь-яким пунктом або з усією угодою в цілому, ви не можете реєструватися в OneForma. Уважно прочитайте наші відповідні політики конфіденційності та правила.",
    h_nofees: "3.5. Відсутність зобов'язань щодо оплати зборів",
    p28: "Ви несете всі та кожні витрати, понесені вами, включаючи, але не обмежуючись, відрядженнями та іншими діловими витратами, понесеними вами або вашими співробітниками, агентами чи підрядниками під час виконання послуг за цією Угодою. Ані CENTIFIC, ані Власник проєкту не несуть відповідальності за будь-які витрати, понесені вами або вашими співробітниками, агентами чи підрядниками під час виконання своїх обов'язків за цією Угодою.",
    h_tax: "3.4. Оподаткування",
    p29: "Для всіх користувачів і платників податків усі ваші податки сплачуються наперед до OneForma. Будь-яким платежем, який ви здійснюєте на користь OneForma, ви підтверджуєте та погоджуєтеся, що OneForma утримала або сплатила будь-який дохід, зарплати, податки на соціальне страхування чи інші податки. OneForma не несе відповідальності за сплату будь-яких страхових внесків (включаючи внески на страхування від безробіття чи непрацездатності) або отримання страхування від нещасних випадків на виробництві. Від вашого імені, якщо інше не передбачено застосовним законодавством, ви зобов'язані відшкодовувати CENTIFIC усі такі податки або внески, включаючи штрафи та відсотки.",
    p30: "Для платників податків в будь-якій іншій юрисдикції ви несете відповідальність за будь-які податки з платежів, отриманих від OneForma. Якщо ви не сплачуєте податки відповідно до застосовного законодавства, OneForma заморозить ваш обліковий запис і без попереднього повідомлення надасть відповідній податковій юрисдикції докази ухилення від сплати податків, безпосередньо звернувшись до суду вашої податкової юрисдикції через OneForma.",
  },

  app: {
    rejected_title: "Виведення відхилено",
  },
};

export default uk;
